import "../Style/LastUpdateTime.css"

const LastUpdateTime = () => {
    return (
        <div className="last-update-time">
            <div>
                Last Update: &ensp;
            </div>
            <div id="LastUpdateTime">
                ---
            </div>
        </div>
    );
}

export default LastUpdateTime;